module.exports = __webpack_public_path__ + "static/media/DDevOps-Company-Service-Details-2024.278b97c8.pdf";